export const DURATION_STEP = 10;
